import { Children, Component, Fragment, JSX, PropsWithChildren, ReactElement, ReactNode, isValidElement } from "react";
import { RouterProps } from "react-router-dom";
import { components } from "../../Components";
import React from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { Guid } from "@iconics/core";
import { LayoutContent } from "./LayoutContent";
import { LayoutFooter } from "./LayoutFooter";
import { LayoutRight } from "./LayoutRight";
import { GridContainer } from "../Grid/GridContainer";
import { GridItem } from "../Grid/GridItem";
import { Stack } from "../Stack/Stack";
import { Box } from "../Box/Box";

export class LayoutContainer extends BaseComponent<ILayoutContainerProps, ILayoutContainerState>
{
    public static layoutContentId = Guid.new().toString();

    private get children(): IChildren
    {
        const children = Children.toArray(this.props.children).filter(isValidElement) as ReactElement[];
        const layoutContents = children.filter(i => i.type == LayoutContent);
        const layoutFooters = children.filter(i => i.type == LayoutFooter);
        const layoutRights = children.filter(i => i.type == LayoutRight);
        const others = children.filter(i => i.type != LayoutContent && i.type != LayoutFooter && i.type != LayoutRight);

        if (layoutContents.length != 1 || layoutFooters.length > 1 || layoutRights.length > 1 || others.length > 0)
        {
            throw new Error('Expected only one LayoutContent, an optional LayoutFooter and an optional LayoutRight.');
        }

        return {
            layoutContent: layoutContents[0],
            layoutFooter: layoutFooters[0],
            layoutRight: layoutRights[0],
        };
    }

    public render(): JSX.Element
    {
        const { layoutContent, layoutFooter, layoutRight } = this.children;

        return (
            <GridContainer
                spacing={0}
            >
                <GridItem
                    compact={layoutRight ? 10 : 12}
                >
                    <Stack>
                        <div
                            style={{
                                padding: '24px',
                                height: `calc(100vh - ${layoutFooter ? '142px' : '88px'})`,
                                overflowY: 'auto',
                            }}
                            onScroll={e => components.handleLayoutContainerScroll(e)}
                            id={LayoutContainer.layoutContentId}
                        >
                            {layoutContent}
                        </div>
                        {
                            !!layoutFooter &&
                            <Box
                                style={{
                                    padding: '16px',
                                    paddingTop: 0,
                                }}
                            >
                                {layoutFooter}
                            </Box>
                        }
                    </Stack>
                </GridItem>
                {
                    !!layoutRight &&
                    <GridItem
                        compact={2}
                        style={{
                            padding: '24px 16px',
                            borderLeft: 'solid rgb(0,0,0,0.1) 1px',
                        }}
                    >
                        {layoutRight}
                    </GridItem>
                }
            </GridContainer>
        );
    }
}

export interface ILayoutContainerProps
{
    children?: React.ReactNode;
}

interface IChildren
{
    layoutContent: React.ReactElement;
    layoutFooter?: React.ReactElement;
    layoutRight?: React.ReactElement;
}

export interface ILayoutContainerState { }
